// services/authContext.ts — Pure React context + type definitions.
// Lives outside auth.tsx so the react-refresh rule treats auth.tsx
// as a "components only" file.

import { createContext } from 'react';
import type { User } from 'firebase/auth';

export type AuthStatus = 'loading' | 'gate' | 'mfa' | 'ready' | 'denied';

export interface AuthContextValue {
  user: User | null;
  status: AuthStatus;
  errorMessage: string | null;
  mfaHint: string | null;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  verifyMfaCode: (code: string) => Promise<void>;
  cancelMfa: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
